module.exports = __webpack_public_path__ + "static/img/k24_kt_02.d2c045a5.png";